import {
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstancew949xxob44bw as Companion_getInstance,
  Vector2I2k5512l4eeahb as Vector2I,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_0,
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_1,
  Vector2D378fe5rov8fgw as Vector2D,
  toIntu0rc68akxu7a as toInt,
} from './korlibs-korlibs-math-vector.mjs';
import {
  Colors_getInstance1qvds1isfbag2 as Colors_getInstance,
  Tilejvhqhoacncec as Tile,
  ASE_getInstance1eqtiryc16lrg as ASE_getInstance,
  readBitmap1dn2o52mvbpv4 as readBitmap,
  Companion_getInstance2fl1toxz5lf8a as Companion_getInstance_2,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  slice2pfxfvku0ybgy as slice,
  Companion_getInstancenwobv30yoie as Companion_getInstance_3,
  TileMapData285v3okd3krdh as TileMapData,
} from './korlibs-korlibs-image.mjs';
import {
  VOID7hggqo3abtya as VOID,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Unit_instance104q5opgivhr8 as Unit_instance,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  getKClass1s3j9wy1cofik as getKClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  toString1pkumu07cwy4m as toString,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  last1vo29oleiqj36 as last,
  plus20p0vtfmu0596 as plus,
  takeLasttm5u17ojwaaq as takeLast,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  numberToDouble210hrknaofnhf as numberToDouble,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance_4,
  isIntArrayeijsubfngq38 as isIntArray,
  lazy2hsh8ze7j6ikd as lazy,
  listOf1jh22dvmctj1r as listOf,
  Random2w0u2xak2xaqi as Random,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Korge11eut3mr7473l as Korge,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views17oaxjs1xed1j as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  addTo25e29vq105prw as addTo,
  Companion_getInstancezug9z9lglek as Companion_getInstance_5,
  Stage1ggtrzujnnkl0 as Stage,
  Container7486fjmip554 as Container,
  SolidRect131p7hyzlx7j8 as SolidRect,
  alphaher384qrj9q4 as alpha,
  Companion_instancecqwbvq0sb4tp as Companion_instance,
  Text3kimhvgfxflj3 as Text,
  xy1gb51vhy014mx as xy,
  get_keysmipauarvwdlb as get_keys,
  tween3jbh5j0ixzsj7 as tween,
  TileMapunot5gnjvpqy as TileMap,
  PixelatedSceneoudxoze5iszc as PixelatedScene,
  intervalfu9yhuucbcwn as interval,
  centerOnStage1tf2oda60yrak as centerOnStage,
  animator38vbqz0qhvd6m as animator,
  Animator3ve4r56t61w8x as Animator,
  show2aeumyubbk4hr as show,
  moveBy2jlfhnymnp65t as moveBy,
  hide1jf8h1e875esy as hide,
  block1zs9asix98nq4 as block,
  Scenezu810y12qpqp as Scene,
  delay1gbwd28dgkhwf as delay,
} from './korge-root-korge.mjs';
import { Companion_getInstancech3bi94cc2ym as Companion_getInstance_6 } from './korlibs-korlibs-math-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  get_EASE_OUT38lbythvs83tj as get_EASE_OUT,
  splitInRows1cyiez6sz0yy1 as splitInRows,
  getff2jwkktgke3 as get,
} from './korlibs-korlibs-math.mjs';
import {
  Resources1ysf2j4wd5yk7 as Resources,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
} from './korlibs-korlibs-io.mjs';
import { Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance } from './korlibs-korlibs-logger.mjs';
import {
  SimpleTileSpecgm148xmxr6nq as SimpleTileSpec,
  SimpleTileProvider1hi5ozcewbzq as SimpleTileProvider,
  SimpleRule2asrxy1xgzifr as SimpleRule,
  CombinedRuleMatcher108ngn6lxba4t as CombinedRuleMatcher,
  IntGridToTileGrid3mza00h4urmkn as IntGridToTileGrid,
} from './korge-snake-korma-tile-matching.mjs';
import {
  TypedEvent2sht3ekuftqke as TypedEvent,
  V22su20mpwty0v0 as V2,
  easing3hki2a7unu7kd as easing,
  KeyEvent3kdv2rq8w0dew as KeyEvent,
  _interpolated0idy8l9id9j as _interpolate,
  Key_UP_getInstanceb8rctup40hnz as Key_UP_getInstance,
  Key_DOWN_getInstance3uv13du3770bq as Key_DOWN_getInstance,
  Key_LEFT_getInstance4xv6s4l9ffcr as Key_LEFT_getInstance,
  Key_RIGHT_getInstancevkjx63tsbibt as Key_RIGHT_getInstance,
  Key_SPACE_getInstance13zcep8fbcon1 as Key_SPACE_getInstance,
} from './korge-root-korge-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instance1nrsidgsshcc7 as Companion_instance_0,
  observe9z1mw8x3w951 as observe,
  Observable19v74jqcsmm4f as Observable,
} from './korlibs-korlibs-datastructure.mjs';
import { get_fast37cu8s8qwnuyi as get_fast } from './korlibs-korlibs-time-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class main$slambda {
  z8d($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$Korge, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.z8d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class GameInfo {
  constructor(score, hiScore) {
    score = score === VOID ? 0 : score;
    hiScore = hiScore === VOID ? 0 : hiScore;
    this.jan_1 = score;
    this.kan_1 = hiScore;
  }
  lan(increment) {
    var newScore = this.jan_1 + increment | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = this.kan_1;
    var tmp$ret$0 = Math.max(a, newScore);
    return new GameInfo(newScore, tmp$ret$0);
  }
  man(score, hiScore) {
    return new GameInfo(score, hiScore);
  }
  nan(score, hiScore, $super) {
    score = score === VOID ? this.jan_1 : score;
    hiScore = hiScore === VOID ? this.kan_1 : hiScore;
    return $super === VOID ? this.man(score, hiScore) : $super.man.call(this, score, hiScore);
  }
  toString() {
    return 'GameInfo(score=' + this.jan_1 + ', hiScore=' + this.kan_1 + ')';
  }
  hashCode() {
    var result = this.jan_1;
    result = imul(result, 31) + this.kan_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GameInfo ? other : THROW_CCE();
    if (!(this.jan_1 === tmp0_other_with_cast.jan_1))
      return false;
    if (!(this.kan_1 === tmp0_other_with_cast.kan_1))
      return false;
    return true;
  }
}
class Snake {
  constructor(list, length) {
    this.oan_1 = list;
    this.pan_1 = length;
  }
  qan() {
    return last(this.oan_1);
  }
  ran(dir) {
    return new Snake(takeLast(plus(this.oan_1, last(this.oan_1).j2d(dir.uan_1)), this.pan_1), this.pan_1);
  }
  wan(map, intMap) {
    var iterator = this.oan_1.z();
    var index = 0;
    while (iterator.a1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var point = iterator.b1();
      intMap.u2d(point, get_EMPTY());
      if (map.x2d(point.w2a_1, point.x2a_1)) {
        while (map.c2n(point.w2a_1, point.x2a_1) > 0) {
          map.d2n(point.w2a_1, point.x2a_1);
        }
      }
    }
  }
  xan(map, intMap) {
    var _iterator__ex2g4s = this.oan_1.z();
    while (_iterator__ex2g4s.a1()) {
      var point = _iterator__ex2g4s.b1();
      intMap.u2d(point, get_SNAKE());
    }
    var iterator = this.oan_1.z();
    var index = 0;
    while (iterator.a1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var point_0 = iterator.b1();
      var isHead = index_0 === (this.oan_1.d1() - 1 | 0);
      // Inline function 'kotlin.collections.getOrElse' call
      var this_0 = this.oan_1;
      var index_1 = index_0 - 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= index_1 ? index_1 < this_0.d1() : false) {
        tmp = this_0.c1(index_1);
      } else {
        // Inline function 'snake.model.Snake.render.<anonymous>' call
        tmp = point_0;
      }
      var prevPoint = tmp;
      // Inline function 'kotlin.collections.getOrElse' call
      var this_1 = this.oan_1;
      var index_2 = index_0 + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index_2 ? index_2 < this_1.d1() : false) {
        tmp_0 = this_1.c1(index_2);
      } else {
        // Inline function 'snake.model.Snake.render.<anonymous>' call
        tmp_0 = point_0;
      }
      var nextPoint = tmp_0;
      var dir = Companion_instance_1.yan(prevPoint, point_0);
      var ndir = Companion_instance_1.yan(point_0, nextPoint);
      var tile = isHead ? SnakeHeadProvider_getInstance().yam(new SimpleTileSpec(dir.equals(SnakeDirection_LEFT_getInstance()), dir.equals(SnakeDirection_UP_getInstance()), dir.equals(SnakeDirection_RIGHT_getInstance()), dir.equals(SnakeDirection_DOWN_getInstance()))) : SnakeProvider_getInstance().yam(new SimpleTileSpec(dir.equals(SnakeDirection_RIGHT_getInstance()) || ndir.equals(SnakeDirection_LEFT_getInstance()), dir.equals(SnakeDirection_DOWN_getInstance()) || ndir.equals(SnakeDirection_UP_getInstance()), dir.equals(SnakeDirection_LEFT_getInstance()) || ndir.equals(SnakeDirection_RIGHT_getInstance()), dir.equals(SnakeDirection_UP_getInstance()) || ndir.equals(SnakeDirection_DOWN_getInstance())));
      map.m5d(point_0.w2a_1, point_0.x2a_1, tile);
    }
  }
  bao(list, length) {
    return new Snake(list, length);
  }
  cao(list, length, $super) {
    list = list === VOID ? this.oan_1 : list;
    length = length === VOID ? this.pan_1 : length;
    return $super === VOID ? this.bao(list, length) : $super.bao.call(this, list, length);
  }
  toString() {
    return 'Snake(list=' + toString(this.oan_1) + ', length=' + this.pan_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.oan_1);
    result = imul(result, 31) + this.pan_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Snake))
      return false;
    var tmp0_other_with_cast = other instanceof Snake ? other : THROW_CCE();
    if (!equals(this.oan_1, tmp0_other_with_cast.oan_1))
      return false;
    if (!(this.pan_1 === tmp0_other_with_cast.pan_1))
      return false;
    return true;
  }
}
class Companion {
  yan(old, new_0) {
    return new_0.w2a_1 > old.w2a_1 ? SnakeDirection_RIGHT_getInstance() : new_0.w2a_1 < old.w2a_1 ? SnakeDirection_LEFT_getInstance() : new_0.x2a_1 > old.x2a_1 ? SnakeDirection_DOWN_getInstance() : new_0.x2a_1 < old.x2a_1 ? SnakeDirection_UP_getInstance() : SnakeDirection_NONE_getInstance();
  }
}
class SnakeDirection extends Enum {
  constructor(name, ordinal, delta, isHorizontal) {
    super(name, ordinal);
    this.uan_1 = delta;
    this.van_1 = isHorizontal;
  }
}
class AppleProvider {
  constructor() {
    AppleProvider_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleTileProvider(APPLE);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'snake.model.AppleProvider.$$delegate_0.<anonymous>' call
    this_0.xam(SimpleRule.ean(Tile(12)));
    tmp.dao_1 = this_0;
  }
  zam(ints, x, y) {
    return this.dao_1.zam(ints, x, y);
  }
  qam() {
    return this.dao_1.oam_1;
  }
}
class WallProvider {
  constructor() {
    WallProvider_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleTileProvider(WALL);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'snake.model.WallProvider.$$delegate_0.<anonymous>' call
    this_0.xam(SimpleRule.ean(Tile(16)));
    this_0.xam(SimpleRule.ean(Tile(17), VOID, VOID, true));
    this_0.xam(SimpleRule.ean(Tile(18), true, VOID, true));
    this_0.xam(SimpleRule.ean(Tile(19), true, VOID, VOID, true));
    this_0.xam(SimpleRule.ean(Tile(20), true, true, VOID, true));
    var tmp0_tile = Tile(21);
    this_0.xam(SimpleRule.ean(tmp0_tile, true, true, true, true));
    tmp.eao_1 = this_0;
  }
  zam(ints, x, y) {
    return this.eao_1.zam(ints, x, y);
  }
  qam() {
    return this.eao_1.oam_1;
  }
}
class SnakeProvider {
  constructor() {
    SnakeProvider_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleTileProvider(SNAKE);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'snake.model.SnakeProvider.$$delegate_0.<anonymous>' call
    this_0.xam(SimpleRule.ean(Tile(0)));
    this_0.xam(SimpleRule.ean(Tile(1), VOID, VOID, true));
    this_0.xam(SimpleRule.ean(Tile(2), true, VOID, true));
    this_0.xam(SimpleRule.ean(Tile(3), true, VOID, VOID, true));
    tmp.zan_1 = this_0;
  }
  yam(spec) {
    return this.zan_1.yam(spec);
  }
  zam(ints, x, y) {
    return this.zan_1.zam(ints, x, y);
  }
  qam() {
    return this.zan_1.oam_1;
  }
}
class SnakeHeadProvider {
  constructor() {
    SnakeHeadProvider_instance = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new SimpleTileProvider(SNAKE);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'snake.model.SnakeHeadProvider.$$delegate_0.<anonymous>' call
    this_0.xam(SimpleRule.ean(Tile(0)));
    this_0.xam(SimpleRule.ean(Tile(4), VOID, VOID, true));
    tmp.aao_1 = this_0;
  }
  yam(spec) {
    return this.aao_1.yam(spec);
  }
  zam(ints, x, y) {
    return this.aao_1.zam(ints, x, y);
  }
  qam() {
    return this.aao_1.oam_1;
  }
}
class Companion_0 {}
class GameInfoUpdatedEvent extends TypedEvent {
  constructor(gameInfo) {
    super(Companion_instance_2);
    this.iao_1 = gameInfo;
  }
}
class Companion_1 {}
class GameStartEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_3);
  }
}
class IngameScene$ingame$ref {
  constructor($boundThis) {
    this.jao_1 = $boundThis;
  }
  kao(p0, $completion) {
    return this.jao_1.nap(p0, $completion);
  }
  pd(p1, $completion) {
    return this.kao(p1 instanceof Container ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$ingame$ref_0 {
  constructor($boundThis) {
    this.vap_1 = $boundThis;
  }
  kao(p0, $completion) {
    return this.vap_1.nap(p0, $completion);
  }
  pd(p1, $completion) {
    return this.kao(p1 instanceof Container ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$ingame$slambda {
  constructor($direction) {
    this.xap_1 = $direction;
  }
  f8s(it, $completion) {
    this.xap_1._v = SnakeDirection_UP_getInstance();
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$ingame$slambda_0 {
  constructor($direction) {
    this.yap_1 = $direction;
  }
  f8s(it, $completion) {
    this.yap_1._v = SnakeDirection_DOWN_getInstance();
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$ingame$slambda_1 {
  constructor($direction) {
    this.zap_1 = $direction;
  }
  f8s(it, $completion) {
    this.zap_1._v = SnakeDirection_LEFT_getInstance();
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$ingame$slambda_2 {
  constructor($direction) {
    this.aaq_1 = $direction;
  }
  f8s(it, $completion) {
    this.aaq_1._v = SnakeDirection_RIGHT_getInstance();
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$ingame$slambda_3 {
  constructor($view) {
    this.baq_1 = $view;
  }
  f8s(it, $completion) {
    this.baq_1.d8k_1 = this.baq_1.d8k_1 === 0.0 ? 1.0 : 0.0;
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$gameOver$slambda {
  constructor(this$0) {
    this.caq_1 = this$0;
  }
  f8s(it, $completion) {
    this.caq_1.daq(IngameScene$ingame$ref_1(this.caq_1));
  }
  pd(p1, $completion) {
    return this.f8s(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  }
}
class IngameScene$gameOver$ref {
  constructor($boundThis) {
    this.eaq_1 = $boundThis;
  }
  kao(p0, $completion) {
    return this.eaq_1.faq(p0, $completion);
  }
  pd(p1, $completion) {
    return this.kao(p1 instanceof Container ? p1 : THROW_CCE(), $completion);
  }
}
class StateScene {}
function runStates(_this__u8e3s4, startingFunc, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_runStates__uxyoex_0(_this__u8e3s4, this, startingFunc, $completion), $completion);
}
function change(func) {
  this.gaq(func);
}
function frame(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_frame__oz9fc7_0(_this__u8e3s4, this, $completion), $completion);
}
class IngameScene extends PixelatedScene {
  constructor() {
    super(512, 512, VOID, VOID, true);
    this.aap_1 = new Mixin();
    var tmp = this;
    tmp.cap_1 = lazy(IngameScene$tiles$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.dap_1 = lazy(IngameScene$tileSet$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.eap_1 = lazy(IngameScene$tileMap$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.fap_1 = lazy(IngameScene$tileMapRules$delegate$lambda);
    var tmp_3 = this;
    tmp_3.gap_1 = lazy(IngameScene$intMap$delegate$lambda(this));
    this.hap_1 = false;
    this.iap_1 = new GameInfo(0);
    this.jap_1 = new Snake(listOf([Vector2I.z2a(5, 5), Vector2I.z2a(6, 5)]), 4);
    var tmp_4 = this;
    tmp_4.kap_1 = new Observable(this.iap_1, VOID, IngameScene$gameInfo$delegate$lambda(this));
    this.lap_1 = this.jap_1;
    this.map_1 = Random(0);
  }
  oap(_this__u8e3s4, startingFunc, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_runStates__uxyoex(_this__u8e3s4, this, startingFunc, $completion), $completion);
  }
  daq(func) {
    this.aap_1.daq(func);
  }
  pap(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_frame__oz9fc7(_this__u8e3s4, this, $completion), $completion);
  }
  gaq(_set____db54di) {
    this.aap_1.haq_1 = _set____db54di;
  }
  iaq() {
    return this.aap_1.haq_1;
  }
  rap() {
    var tmp = this.bap_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('tilesBmp');
    }
  }
  sap() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.cap_1;
    tiles$factory();
    return this_0.t1();
  }
  tap() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.dap_1;
    tileSet$factory();
    return this_0.t1();
  }
  qap() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.eap_1;
    tileMap$factory();
    return this_0.t1();
  }
  uap() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.fap_1;
    tileMapRules$factory();
    return this_0.t1();
  }
  jaq() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.gap_1;
    intMap$factory();
    return this_0.t1();
  }
  kaq(_set____db54di) {
    return this.kap_1.b2o(this, gameInfo$factory(), _set____db54di);
  }
  laq() {
    return this.kap_1.a2o(this, gameInfo$factory_0());
  }
  w8x(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneInit__5zuhe0(_this__u8e3s4, this, $completion), $completion);
  }
  x8x(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl(_this__u8e3s4, this, $completion), $completion);
  }
  nap(view, $completion) {
    this.jaq().v2d(RectangleInt.j2a(0, 0, this.jaq().n2d(), this.jaq().o2d()), get_EMPTY());
    this.jaq().v2d(RectangleInt.j2a(0, 0, this.jaq().n2d(), 1), get_WALL());
    this.jaq().v2d(RectangleInt.j2a(0, this.jaq().o2d() - 1 | 0, this.jaq().n2d(), 1), get_WALL());
    this.jaq().v2d(RectangleInt.j2a(0, 0, 1, this.jaq().o2d()), get_WALL());
    this.jaq().v2d(RectangleInt.j2a(this.jaq().n2d() - 1 | 0, 0, 1, this.jaq().o2d()), get_WALL());
    this.jaq().v2d(RectangleInt.j2a(8, 8, 3, 3), get_WALL());
    this.jaq().v2d(RectangleInt.j2a(16, 20, 4, 10), get_WALL());
    this.hap_1 = false;
    this.kaq(this.laq().nan(0));
    this.lap_1 = this.jap_1;
    this.maq();
    this.naq();
    this.j8v().x5q(new GameStartEvent());
    this.jaq().t2d(4, 3, get_WALL());
    this.jaq().t2d(4, 4, get_WALL());
    this.jaq().t2d(3, 4, get_WALL());
    this.jaq().t2d(4, 5, get_WALL());
    var direction = {_v: SnakeDirection_RIGHT_getInstance()};
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance_4();
    var tmp = toDuration(0.1, DurationUnit_SECONDS_getInstance());
    interval(view, tmp, IngameScene$ingame$lambda(this, direction));
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'snake.scene.IngameScene.ingame.<anonymous>' call
    var $this$keys = get_keys(view);
    var tmp_0 = Key_UP_getInstance();
    $this$keys.i8s(tmp_0, IngameScene$ingame$slambda_4(direction));
    var tmp_1 = Key_DOWN_getInstance();
    $this$keys.i8s(tmp_1, IngameScene$ingame$slambda_5(direction));
    var tmp_2 = Key_LEFT_getInstance();
    $this$keys.i8s(tmp_2, IngameScene$ingame$slambda_6(direction));
    var tmp_3 = Key_RIGHT_getInstance();
    $this$keys.i8s(tmp_3, IngameScene$ingame$slambda_7(direction));
    var tmp_4 = Key_SPACE_getInstance();
    $this$keys.i8s(tmp_4, IngameScene$ingame$slambda_8(view));
  }
  faq(view, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_gameOver__jcjkm6(this, view, $completion), $completion);
  }
  naq() {
    this.lap_1.xan(this.qap().eai_1, this.jaq());
  }
  maq() {
    while (true) {
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_0();
      var width = this.jaq().n2d() - 0.5;
      var height = this.jaq().o2d() - 0.5;
      var tmp = Companion_getInstance_0();
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance_1();
      var tmp_0 = Vector2D.j21(numberToDouble(0), numberToDouble(0));
      // Inline function 'korlibs.math.geom.Companion.invoke' call
      Companion_getInstance();
      var tmp$ret$1 = Size2D.t29(numberToDouble(width), numberToDouble(height));
      var tmp$ret$2 = tmp.b23(tmp_0, tmp$ret$1);
      var point = get(this.map_1, tmp$ret$2);
      var ipoint = toInt(point);
      if (this.jaq().d2e(ipoint) === get_EMPTY()) {
        this.jaq().u2d(ipoint, get_APPLE());
        return Unit_instance;
      }
    }
  }
  wap(dir) {
    var oldSnake = this.lap_1;
    this.lap_1 = this.lap_1.ran(dir);
    var headValue = this.jaq().d2e(this.lap_1.qan());
    var isApple = headValue === get_APPLE();
    if (isApple) {
      this.lap_1 = this.lap_1.cao(VOID, this.lap_1.pan_1 + 1 | 0);
      this.kaq(this.laq().lan(1));
    } else if (!(headValue === get_EMPTY())) {
      this.daq(IngameScene$gameOver$ref_0(this));
      return Unit_instance;
    }
    oldSnake.wan(this.qap().eai_1, this.jaq());
    this.lap_1.xan(this.qap().eai_1, this.jaq());
    if (isApple) {
      this.maq();
    }
  }
}
class OverlayScene extends Scene {
  x8x(_this__u8e3s4, $completion) {
    // Inline function 'korlibs.korge.view.xy' call
    // Inline function 'korlibs.korge.view.text' call
    var textSize = Companion_instance.kad_1;
    var color = Colors_getInstance().k3n_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_2().u4c_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.lad_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Text.pad('', numberToDouble(textSize), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    var scoreText = xy(this_1, numberToDouble(8), numberToDouble(8));
    var current = {_v: new GameInfo()};
    var hiScoreBeatShown = {_v: false};
    var tmp = Companion_instance_3;
    _this__u8e3s4.m5q(tmp, OverlayScene$sceneMain$lambda(hiScoreBeatShown));
    var tmp_0 = Companion_instance_2;
    _this__u8e3s4.m5q(tmp_0, OverlayScene$sceneMain$lambda_0(current, scoreText, hiScoreBeatShown, this));
  }
}
class Mixin {
  constructor() {
    this.haq_1 = null;
  }
  gaq(_set____db54di) {
    this.haq_1 = _set____db54di;
  }
  iaq() {
    return this.haq_1;
  }
}
class ChangeSceneException extends Error {
  static aar(func) {
    var $this = createThis(this);
    setPropertiesToThrowableInstance($this);
    captureStack($this, $this.zaq_1);
    $this.yaq_1 = func;
    return $this;
  }
}
//endregion
function main($completion) {
  var tmp = Size2D.a23(512, 512);
  var tmp_0 = Colors_getInstance().j44('#2b2b2b');
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$Korge, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name = 'sceneContainer';
  var size = Companion_getInstance().t2b_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp = views($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var views_0 = tmp;
  var width = size.rk();
  var height = size.sk();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_0 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
    var tmp0_elvis_lhs = base == null ? null : base.n2d();
    rwidth = tmp0_elvis_lhs == null ? views_0.q8i_1.n2d() : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = base == null ? null : base.o2d();
    rheight = tmp1_elvis_lhs == null ? views_0.q8i_1.o2d() : tmp1_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.r8o(views_0, defaultTransition, name, Size2D.t29(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, $this$Korge);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_1.m8o_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(IngameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_1.l8o_1.g8h_1.s5n().q5n(getKClass(SceneContainer), this_1).q5n(getKClass(Resources), new Resources(this_1.fy(), this_1.l8o_1.n8p().a2x_1, this_1.l8o_1.n8p()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_1 = getKClassFromExpression(inject);
    sceneInjector.q5n(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new IngameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_2 = Companion_getInstance_5().p8z_1;
  var level = Level_INFO_getInstance();
  var tmp_2;
  if (this_2.m2q(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_2.n2q(level, tmp$ret$8);
    tmp_2 = Unit_instance;
  }
  if (true) {
    newScene.b5o(sceneInjector);
    var tmp_3 = getKClassFromExpression(newScene);
    var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
    this_1.l8o_1.g8h_1.u5n(tmp_4, main$slambda$lambda_0(sceneInjector));
  }
  var tmp_5 = this_1.r8z(newScene, time, transition, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new IngameScene();
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.z8d($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
var SnakeDirection_UP_instance;
var SnakeDirection_DOWN_instance;
var SnakeDirection_LEFT_instance;
var SnakeDirection_RIGHT_instance;
var SnakeDirection_NONE_instance;
var Companion_instance_1;
function Companion_getInstance_7() {
  return Companion_instance_1;
}
var SnakeDirection_entriesInitialized;
function SnakeDirection_initEntries() {
  if (SnakeDirection_entriesInitialized)
    return Unit_instance;
  SnakeDirection_entriesInitialized = true;
  SnakeDirection_UP_instance = new SnakeDirection('UP', 0, Vector2I.z2a(0, -1), false);
  SnakeDirection_DOWN_instance = new SnakeDirection('DOWN', 1, Vector2I.z2a(0, 1), false);
  SnakeDirection_LEFT_instance = new SnakeDirection('LEFT', 2, Vector2I.z2a(-1, 0), true);
  SnakeDirection_RIGHT_instance = new SnakeDirection('RIGHT', 3, Vector2I.z2a(1, 0), true);
  SnakeDirection_NONE_instance = new SnakeDirection('NONE', 4, Vector2I.z2a(0, 0), null);
}
function SnakeDirection_UP_getInstance() {
  SnakeDirection_initEntries();
  return SnakeDirection_UP_instance;
}
function SnakeDirection_DOWN_getInstance() {
  SnakeDirection_initEntries();
  return SnakeDirection_DOWN_instance;
}
function SnakeDirection_LEFT_getInstance() {
  SnakeDirection_initEntries();
  return SnakeDirection_LEFT_instance;
}
function SnakeDirection_RIGHT_getInstance() {
  SnakeDirection_initEntries();
  return SnakeDirection_RIGHT_instance;
}
function SnakeDirection_NONE_getInstance() {
  SnakeDirection_initEntries();
  return SnakeDirection_NONE_instance;
}
function get_EMPTY() {
  return EMPTY;
}
var EMPTY;
function get_APPLE() {
  return APPLE;
}
var APPLE;
function get_WALL() {
  return WALL;
}
var WALL;
function get_SNAKE() {
  return SNAKE;
}
var SNAKE;
var AppleProvider_instance;
function AppleProvider_getInstance() {
  if (AppleProvider_instance === VOID)
    new AppleProvider();
  return AppleProvider_instance;
}
var WallProvider_instance;
function WallProvider_getInstance() {
  if (WallProvider_instance === VOID)
    new WallProvider();
  return WallProvider_instance;
}
var SnakeProvider_instance;
function SnakeProvider_getInstance() {
  if (SnakeProvider_instance === VOID)
    new SnakeProvider();
  return SnakeProvider_instance;
}
var SnakeHeadProvider_instance;
function SnakeHeadProvider_getInstance() {
  if (SnakeHeadProvider_instance === VOID)
    new SnakeHeadProvider();
  return SnakeHeadProvider_instance;
}
var Companion_instance_2;
function Companion_getInstance_8() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_9() {
  return Companion_instance_3;
}
function IngameScene$ingame$ref_1($boundThis) {
  var i = new IngameScene$ingame$ref($boundThis);
  var l = function (p0, $completion) {
    return i.kao(p0, $completion);
  };
  l.callableName = 'ingame';
  l.$arity = 1;
  return l;
}
function *_generator_runStates__uxyoex(_this__u8e3s4, $this, startingFunc, $completion) {
  var tmp = $this.aap_1.oap(_this__u8e3s4, startingFunc, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_frame__oz9fc7(_this__u8e3s4, $this, $completion) {
  var tmp = $this.aap_1.pap(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_sceneInit__5zuhe0(_this__u8e3s4, $this, $completion) {
  var tmp = $this;
  var tmp_0 = readBitmap(get_resourcesVfs().lh('gfx/tiles.ase'), ASE_getInstance(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.bap_1 = tmp_0.d3u();
  $this.qap();
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_6()));
  var name = 'sceneContainer';
  var size = Companion_getInstance().t2b_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp_1 = views($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var views_0 = tmp_1;
  var width = size.rk();
  var height = size.sk();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_2 = findFirstAscendant(_this__u8e3s4, IngameScene$sceneInit$lambda);
    var base = (tmp_2 == null ? true : tmp_2 instanceof FixedSizeContainer) ? tmp_2 : null;
    var tmp0_elvis_lhs = base == null ? null : base.n2d();
    rwidth = tmp0_elvis_lhs == null ? views_0.q8i_1.n2d() : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = base == null ? null : base.o2d();
    rheight = tmp1_elvis_lhs == null ? views_0.q8i_1.o2d() : tmp1_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.r8o(views_0, defaultTransition, name, Size2D.t29(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_1.m8o_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(OverlayScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_1.l8o_1.g8h_1.s5n().q5n(getKClass(SceneContainer), this_1).q5n(getKClass(Resources), new Resources(this_1.fy(), this_1.l8o_1.n8p().a2x_1, this_1.l8o_1.n8p()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_3 = getKClassFromExpression(inject);
    sceneInjector.q5n(isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE(), inject);
  }
  // Inline function 'snake.scene.IngameScene.sceneInit.<anonymous>' call
  var newScene = new OverlayScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_2 = Companion_getInstance_5().p8z_1;
  var level = Level_INFO_getInstance();
  var tmp_4;
  if (this_2.m2q(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_2.n2q(level, tmp$ret$8);
    tmp_4 = Unit_instance;
  }
  if (true) {
    newScene.b5o(sceneInjector);
    var tmp_5 = getKClassFromExpression(newScene);
    var tmp_6 = isInterface(tmp_5, KClass) ? tmp_5 : THROW_CCE();
    this_1.l8o_1.g8h_1.u5n(tmp_6, IngameScene$sceneInit$lambda_0(sceneInjector));
  }
  var tmp_7 = this_1.r8z(newScene, time, transition, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  return Unit_instance;
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  var tmp = $this.oap(_this__u8e3s4, IngameScene$ingame$ref_2($this), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_gameOver__jcjkm6($this, view, $completion) {
  // Inline function 'kotlin.with' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.alpha' call
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = view.n2d();
  var height = view.o2d();
  var color = Colors_getInstance().l3n_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.ha9(Size2D.t29(width, height), color);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, view);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  var background = alpha(this_1, numberToDouble(0.0));
  // Inline function 'korlibs.korge.view.text' call
  var text = 'GAME OVER';
  var alignment = Companion_getInstance_2().d4d_1;
  var color_0 = Colors_getInstance().k3n_1;
  var font = get_DefaultTtfFontAsBitmap();
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.lad_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Text.pad(text, numberToDouble(1.0), color_0, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, view);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  var text_0 = xy(this_3, view.n2d() * 0.5, view.o2d() * 0.5);
  view.d8k_1 = 0.0;
  // Inline function 'korlibs.korge.input.keys' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'snake.scene.IngameScene.gameOver.<anonymous>.<anonymous>' call
  get_keys(view).h8s(IngameScene$gameOver$slambda_0($this));
  // Inline function 'korlibs.korge.tween.easeOut' call
  // Inline function 'korlibs.korge.tween.get' call
  var this_4 = textSize$factory(text_0);
  var tmp = this_4.get();
  var this_5 = new V2(this_4, tmp, 64.0, _interpolate$ref(), false);
  var tmp_0 = easing(this_5, get_EASE_OUT(Companion_getInstance_6()));
  // Inline function 'korlibs.korge.tween.get' call
  var this_6 = alpha$factory(background);
  var tmp_1 = this_6.get();
  var tmp_2 = [tmp_0, new V2(this_6, tmp_1, 0.5, _interpolate$ref_0(), false)];
  // Inline function 'kotlin.time.Companion.seconds' call
  Companion_getInstance_4();
  var tmp$ret$15 = toDuration(0.5, DurationUnit_SECONDS_getInstance());
  var tmp_3 = tween(view, tmp_2, tmp$ret$15, VOID, VOID, VOID, VOID, VOID, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function IngameScene$tiles$delegate$lambda(this$0) {
  return function () {
    return splitInRows(slice(this$0.rap()), 16, 16);
  };
}
function IngameScene$tileSet$delegate$lambda(this$0) {
  return function () {
    return Companion_getInstance_3().r5d(16, 16, this$0.sap(), 0);
  };
}
function IngameScene$tileMap$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.korge.view.tiles.tileMap' call
    var this_0 = this$0.j8v();
    var map = TileMapData.g5d(32, 32, this$0.tap());
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = TileMap.daj(map, map.c5d_1, true, map.c5d_1.e5e()).eaj(map.d5d_1, map.e5d_1);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.tiles.tileMap.<anonymous>' call
    return addTo(this_1, this_0);
  };
}
function IngameScene$tileMapRules$delegate$lambda() {
  return CombinedRuleMatcher.ian([WallProvider_getInstance(), AppleProvider_getInstance()]);
}
function IngameScene$intMap$delegate$lambda$lambda(this$0) {
  return function ($this$observe, it) {
    var tmp = $this$observe.t2g();
    IntGridToTileGrid(tmp instanceof IntArray2 ? tmp : THROW_CCE(), this$0.uap(), this$0.qap().eai_1, it);
    return Unit_instance;
  };
}
function IngameScene$intMap$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this$0.qap().eai_1.n2d();
    var height = this$0.qap().eai_1.o2d();
    var fill = get_EMPTY();
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = fill;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var tmp_3 = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    return observe(tmp_3, IngameScene$intMap$delegate$lambda$lambda(this$0));
  };
}
function IngameScene$gameInfo$delegate$lambda(this$0) {
  return function (it) {
    this$0.j8v().x5q(new GameInfoUpdatedEvent(it));
    return Unit_instance;
  };
}
function IngameScene$sceneInit$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function IngameScene$sceneInit$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'snake.scene.IngameScene.sceneInit.<anonymous>' call
    return new OverlayScene();
  };
}
function IngameScene$ingame$ref_2($boundThis) {
  var i = new IngameScene$ingame$ref_0($boundThis);
  var l = function (p0, $completion) {
    return i.kao(p0, $completion);
  };
  l.callableName = 'ingame';
  l.$arity = 1;
  return l;
}
function IngameScene$ingame$lambda(this$0, $direction) {
  return function () {
    this$0.wap($direction._v);
    return Unit_instance;
  };
}
function IngameScene$ingame$slambda_4($direction) {
  var i = new IngameScene$ingame$slambda($direction);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IngameScene$ingame$slambda_5($direction) {
  var i = new IngameScene$ingame$slambda_0($direction);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IngameScene$ingame$slambda_6($direction) {
  var i = new IngameScene$ingame$slambda_1($direction);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IngameScene$ingame$slambda_7($direction) {
  var i = new IngameScene$ingame$slambda_2($direction);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IngameScene$ingame$slambda_8($view) {
  var i = new IngameScene$ingame$slambda_3($view);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function IngameScene$gameOver$slambda_0(this$0) {
  var i = new IngameScene$gameOver$slambda(this$0);
  var l = function (it, $completion) {
    return i.f8s(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function _interpolate$ref() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.rt_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function _interpolate$ref_0() {
  var l = function (p0, p1, p2) {
    return _interpolate(p0.rt_1, p1, p2);
  };
  l.callableName = '_interpolate';
  return l;
}
function IngameScene$gameOver$ref_0($boundThis) {
  var i = new IngameScene$gameOver$ref($boundThis);
  var l = function (p0, $completion) {
    return i.kao(p0, $completion);
  };
  l.callableName = 'gameOver';
  l.$arity = 1;
  return l;
}
function tiles$factory() {
  return getPropertyCallableRef('tiles', 1, KProperty1, function (receiver) {
    return receiver.sap();
  }, null);
}
function tileSet$factory() {
  return getPropertyCallableRef('tileSet', 1, KProperty1, function (receiver) {
    return receiver.tap();
  }, null);
}
function tileMap$factory() {
  return getPropertyCallableRef('tileMap', 1, KProperty1, function (receiver) {
    return receiver.qap();
  }, null);
}
function tileMapRules$factory() {
  return getPropertyCallableRef('tileMapRules', 1, KProperty1, function (receiver) {
    return receiver.uap();
  }, null);
}
function intMap$factory() {
  return getPropertyCallableRef('intMap', 1, KProperty1, function (receiver) {
    return receiver.jaq();
  }, null);
}
function gameInfo$factory() {
  return getPropertyCallableRef('gameInfo', 1, KMutableProperty1, function (receiver) {
    return receiver.laq();
  }, function (receiver, value) {
    return receiver.kaq(value);
  });
}
function gameInfo$factory_0() {
  return getPropertyCallableRef('gameInfo', 1, KMutableProperty1, function (receiver) {
    return receiver.laq();
  }, function (receiver, value) {
    return receiver.kaq(value);
  });
}
function textSize$factory($b0) {
  return getPropertyCallableRef('textSize', 0, KMutableProperty0, function () {
    return $b0.fac_1;
  }, function (value) {
    return $b0.rad(value);
  });
}
function alpha$factory($b0) {
  return getPropertyCallableRef('alpha', 0, KMutableProperty0, function () {
    return $b0.za6();
  }, function (value) {
    return $b0.ya6(value);
  });
}
function sceneMain$updateGameInfo(scoreText, hiScoreBeatShown, this$0, old, new_0) {
  scoreText.qad('Score: ' + new_0.jan_1 + ', HI-Score: ' + new_0.kan_1);
  if (new_0.kan_1 > old.kan_1 && !hiScoreBeatShown._v) {
    hiScoreBeatShown._v = true;
    // Inline function 'korlibs.korge.view.alpha' call
    // Inline function 'korlibs.korge.view.text' call
    var this_0 = this$0.j8v();
    var text = 'Hi-Score beaten';
    var color = Colors_getInstance().k3n_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_2().u4c_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.lad_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Text.pad(text, numberToDouble(32.0), color, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    var this_3 = centerOnStage(this_2);
    var text_0 = alpha(this_3, numberToDouble(0.0));
    var tmp = this$0.j8v();
    animator(tmp, VOID, VOID, VOID, VOID, VOID, VOID, OverlayScene$sceneMain$updateGameInfo$lambda(text_0));
  }
}
function OverlayScene$sceneMain$lambda($hiScoreBeatShown) {
  return function (it) {
    $hiScoreBeatShown._v = false;
    return Unit_instance;
  };
}
function OverlayScene$sceneMain$lambda_0($current, $scoreText, $hiScoreBeatShown, this$0) {
  return function (it) {
    sceneMain$updateGameInfo($scoreText, $hiScoreBeatShown, this$0, $current._v, it.iao_1);
    $current._v = it.iao_1;
    return Unit_instance;
  };
}
function OverlayScene$sceneMain$updateGameInfo$lambda$lambda($text) {
  return function () {
    $text.z9a();
    return Unit_instance;
  };
}
function OverlayScene$sceneMain$updateGameInfo$lambda($text) {
  return function ($this$animator) {
    // Inline function 'korlibs.korge.animate.Animator.parallel' call
    var time = $this$animator.h8r();
    var speed = $this$animator.g8q_1;
    var easing = $this$animator.h8q_1;
    var startImmediately = $this$animator.n8q_1;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.also' call
    var tmp7_root = $this$animator.e8q_1;
    var tmp8_fastDefaultTime = get_fast(time);
    var tmp9_level = $this$animator.m8q_1 + 1 | 0;
    var this_0 = new Animator(tmp7_root, tmp8_fastDefaultTime, speed, easing, true, false, $this$animator, VOID, tmp9_level, startImmediately);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.parallel.<anonymous>' call
    // Inline function 'snake.scene.OverlayScene.sceneMain.updateGameInfo.<anonymous>.<anonymous>' call
    show(this_0, $text);
    moveBy(this_0, $text, 0.0, 32.0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.animate.Animator.parallel.<anonymous>' call
    $this$animator.j8r(this_0.u8q_1);
    hide($this$animator, $text);
    block($this$animator, VOID, OverlayScene$sceneMain$updateGameInfo$lambda$lambda($text));
    return Unit_instance;
  };
}
function *_generator_runStates__uxyoex_0(_this__u8e3s4, $this, startingFunc, $completion) {
  var func = startingFunc;
  while (true) {
    // Inline function 'korlibs.korge.view.fixedSizeContainer' call
    var size = _this__u8e3s4.d1();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = FixedSizeContainer.t9x(size, false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fixedSizeContainer.<anonymous>' call
    var stateView = addTo(this_0, _this__u8e3s4);
    try {
      var tmp = func(stateView, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      while (true) {
        var tmp_0 = $this.pap(_this__u8e3s4, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
      }
    } catch ($p) {
      if ($p instanceof ChangeSceneException) {
        var e = $p;
        func = e.yaq_1;
      } else {
        throw $p;
      }
    }
    finally {
      stateView.z9a();
    }
  }
  return Unit_instance;
}
function *_generator_frame__oz9fc7_0(_this__u8e3s4, $this, $completion) {
  var newState = $this.iaq();
  if (!(newState == null)) {
    $this.gaq(null);
    throw ChangeSceneException.aar(newState);
  }
  // Inline function 'korlibs.time.milliseconds' call
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance_4();
  var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
  var tmp = delay(_this__u8e3s4, tmp$ret$1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
//region block: post-declaration
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForClass(GameInfo, 'GameInfo', GameInfo);
initMetadataForClass(Snake, 'Snake');
initMetadataForCompanion(Companion);
initMetadataForClass(SnakeDirection, 'SnakeDirection');
initMetadataForObject(AppleProvider, 'AppleProvider');
initMetadataForObject(WallProvider, 'WallProvider');
initMetadataForObject(SnakeProvider, 'SnakeProvider');
initMetadataForObject(SnakeHeadProvider, 'SnakeHeadProvider');
initMetadataForCompanion(Companion_0);
initMetadataForClass(GameInfoUpdatedEvent, 'GameInfoUpdatedEvent');
initMetadataForCompanion(Companion_1);
initMetadataForClass(GameStartEvent, 'GameStartEvent', GameStartEvent);
initMetadataForFunctionReference(IngameScene$ingame$ref, VOID, VOID, [1]);
initMetadataForFunctionReference(IngameScene$ingame$ref_0, VOID, VOID, [1]);
initMetadataForLambda(IngameScene$ingame$slambda, VOID, VOID, [1]);
initMetadataForLambda(IngameScene$ingame$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(IngameScene$ingame$slambda_1, VOID, VOID, [1]);
initMetadataForLambda(IngameScene$ingame$slambda_2, VOID, VOID, [1]);
initMetadataForLambda(IngameScene$ingame$slambda_3, VOID, VOID, [1]);
initMetadataForLambda(IngameScene$gameOver$slambda, VOID, VOID, [1]);
initMetadataForFunctionReference(IngameScene$gameOver$ref, VOID, VOID, [1]);
initMetadataForInterface(StateScene, 'StateScene', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(IngameScene, 'IngameScene', IngameScene, VOID, [PixelatedScene, StateScene], [1, 0]);
initMetadataForClass(OverlayScene, 'OverlayScene', OverlayScene, VOID, VOID, [0]);
protoOf(Mixin).oap = runStates;
protoOf(Mixin).daq = change;
protoOf(Mixin).pap = frame;
initMetadataForClass(Mixin, 'Mixin', Mixin, VOID, [StateScene], [1, 0]);
initMetadataForClass(ChangeSceneException, 'ChangeSceneException');
//endregion
//region block: init
Companion_instance_1 = new Companion();
EMPTY = 0;
APPLE = 1;
WALL = 2;
SNAKE = 3;
Companion_instance_2 = new Companion_0();
Companion_instance_3 = new Companion_1();
//endregion
mainWrapper();
